export class AuthState {
  public isAuthenticated: boolean;
  public isAuthenticating: boolean;

  constructor() {
    this.isAuthenticated = false;
    this.isAuthenticating = false;
  }
}
